<div [formGroup]="f">
    <fieldset class="ontario-fieldset">
        <legend class="ontario-fieldset__legend ontario-fieldset__legend--large remove-legend-cursor-pointer">
            {{ 'search.within' | translate | async}}
        </legend>

        <div class="ontario-form-group">
            <div class="ontario-checkboxes">
                <mat-radio-group (change)="onResultTypeChange($event)">
                    <mat-radio-button class="flex-child flex-child--full-width resultTypeOptions" *ngFor="let resultType of constants.RESULT_TYPE_OPTIONS"
                        attr.aria-label=" {{ resultType.i18nkey | translate | async }}" [value]="resultType.id" [checked]="resultType.checked">
                        {{ resultType.i18nkey | translate | async}}
                        
                        <ng-container *ngIf="resultType.id == 0; else pdfResultsCard">
                            <div class="ml-1 iconStyling">
                                <img src="../../../../assets/images/record-icon-yellow.png" 
                                    alt="{{ 'recordIcon' | translate | async }}" 
                                    attr.aria-label="{{ 'recordIcon' | translate | async }}" aria-hidden="true">
                            </div>
                        </ng-container>
                        <ng-template #pdfResultsCard>
                            <div class="ml-1 iconStyling">
                                <img src="../../../../assets/images/pdf-icon-blue.png" 
                                    alt="{{ 'documentIcon' | translate | async }}" 
                                    attr.aria-label="{{ 'documentIcon' | translate | async }}" aria-hidden="true">
                            </div>
                        </ng-template>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </fieldset>
</div>